<script lang="ts">
  interface Props {
    config: { allowed_senders?: string[] };
    inboundAddress: string | null;  // null when creating (not yet saved)
  }
  let { config = $bindable(), inboundAddress }: Props = $props();

  let allowlistText = $state((config.allowed_senders ?? []).join('\n'));

  $effect(() => {
    const list = allowlistText
      .split(/\r?\n/)
      .map(s => s.trim())
      .filter(s => s.length > 0);
    config = { ...config, allowed_senders: list };
  });

  async function copyAddress() {
    if (!inboundAddress) return;
    await navigator.clipboard.writeText(inboundAddress);
  }
</script>

<div class="email-config">
  {#if inboundAddress}
    <p class="address-label">Send alerts to:</p>
    <div class="address-row">
      <code>{inboundAddress}</code>
      <button type="button" onclick={copyAddress}>Copy</button>
    </div>
  {:else}
    <p class="hint">Your unique inbound address will be shown after you save.</p>
  {/if}

  <label for="allowlist">Sender allowlist (optional, one per line):</label>
  <textarea id="allowlist" bind:value={allowlistText} rows="4"
            placeholder="alerts@district.k12.us"></textarea>
  <p class="hint">Leave empty to accept email from anyone. Your reviewer is still the gate.</p>
</div>

<style>
  .email-config { margin: 1rem 0; }
  .address-label { font-size: .85rem; font-weight: 600; color: #444; margin: 0 0 .25rem; }
  .address-row { display: flex; gap: .5rem; align-items: center; margin: 0 0 1rem; }
  .address-row code { background: #f4f4f4; padding: .25rem .5rem; border-radius: 4px; flex: 1; }
  .hint { color: #666; font-size: .9rem; margin: .25rem 0 .75rem; }
  textarea { width: 100%; font-family: monospace; }
</style>
